export enum Pathnames {
  ContextSources = '/context',
  ContextSourcesByContextSourceId = '/context/[contextSourceId]',
  FavoriteItems = '/favorite-items',
  MyUploads = '/my-uploads',
  People = '/people',
  RecentlyAdded = '/recently-added',
  RecentlyDeleted = '/recently-deleted',
  RecentlyModified = '/recently-modified',
  Search = '/all',
  UntaggedItems = '/untagged-items',
  UnusedItems = '/unused-items',
  ShareLinks = '/share-links',
  Skills = '/skills',
  MyCanvases = '/canvases',
}
